import { AxiosError } from 'axios';
import { PaymentAccessResponse } from 'web-library/models/Payment';
import { GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../../hooks/query';
import { GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS_QUERY_KEY } from '../../constants/queryKeys';

interface Input {
  onSuccess?: (res: PaymentAccessResponse) => void;
  onError?: (error: AxiosError) => void;
  organisationUuid: string;
  enabled: boolean;
}

export const useGetSchoolCandidatePaymentAccess = ({
  onSuccess,
  onError,
  organisationUuid,
  enabled,
}: Input) => {
  const getSchoolCandidatePaymentAccess = async () => {
    const res = await axiosClient.get<PaymentAccessResponse>(
      GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS(organisationUuid)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS_QUERY_KEY, organisationUuid],
    getSchoolCandidatePaymentAccess,
    {
      onSuccess,
      onError,
      enabled,
    },
    true,
    false
  );
};
